module.exports = __webpack_public_path__ + "static/media/step-indicator-1.5351b196.svg";